import React from "react"
import { Link } from "gatsby"

import Img from "gatsby-image"
import site from "../../utilty/getURL"
import { StaticQuery, graphql } from "gatsby"
export default function HomeCatSlider({ data, headLine, slug }) {
  return (
    <StaticQuery
      query={moviesatQurey}
      render={data => {
        return (
          <div className="w-100 p-0 m-0">
            <hr className=" mb-0" />
            <div className=" ">
              <h6 className=" p-2 mb-0 font-weight-bold ">
                <Link
                  to={`${site.siteMetadata.siteUrl}/${slug}`}
                  className="text-dark"
                >
                  {headLine}
                </Link>{" "}
              </h6>
              <hr className="mt-0 mb-1" />
            </div>
            <div className="border myScrollH pb-1 d-flex p-2">
              {data.allContentfulBlogPost.edges.map(({ node }) => {
                return (
                  <div className="d-inline m-1 cardHover " key={node.title}>
                    <Link
                      to={`${site.siteMetadata.siteUrl}/${node.slug}`}
                      className="text-dark"
                    >
                      <div class="card mb-0" style={{ width: "18rem" }}>
                        <Img
                          fluid={node.heroImage.fluid}
                          className="h-100"
                          alt={node.title}
                        />
                        <div class="card-body">
                          <p class="card-text">
                            <h6>{node.title}</h6>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                )
              })}
              <div className="ml-auto p-2 d-block">
                <Link to={`${site.siteMetadata.siteUrl}/${slug}`}>
                  See More
                </Link>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

//  category.description

export const moviesatQurey = graphql`
  query {
    allContentfulBlogPost(
      sort: { fields: [publishDate], order: DESC }
      filter: { category: { elemMatch: { title: { eq: "Education" } } } }
    ) {
      edges {
        node {
          author {
            name
          }
          category {
            title
            description
          }
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          tags
          heroImage {
            fluid(maxWidth: 350, maxHeight: 196, resizingBehavior: SCALE) {
              ...GatsbyContentfulFluid
              base64
              # tracedSVG
              srcWebp
              srcSetWebp
            }
          }
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`
